import { createSlice } from '@reduxjs/toolkit';

export const paymentClientSlice = createSlice({
  name: 'paymentClient',
  initialState: {
    clientId: '',
    serviceId: '',
    transactionId: '',
    merchantName: '',
    sourceOrigin: '',
    domains: []
  },
  reducers: {
    setData: (state, action) => {
      const { clientId, serviceId, transactionId, merchantName, sourceOrigin, domains } = action.payload;
      state.clientId = clientId;
      state.serviceId = serviceId;
      state.transactionId = transactionId;
      state.merchantName = merchantName;
      state.sourceOrigin = sourceOrigin;
      state.domains = domains;
    },
  },
});

export const { setData } = paymentClientSlice.actions;
export default paymentClientSlice.reducer;